import React from 'react'

import s from './styles.module.scss'

export const ModalSelectProposalClientRequestBackofficeLayout = ({
  elements,
}: {
  elements: React.ReactNode
}) => {
  return <div className={s.container}>{elements}</div>
}
